module.exports = __webpack_public_path__ + "static/media/assessment.2096ea04.png";